'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _ProjectIrefImage = require('components/ProjectIrefImage/ProjectIrefImage');

var _ProjectIrefImage2 = _interopRequireDefault(_ProjectIrefImage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./ProjectLegendLine.scss');

var ProjectLegendLine = (_temp = _class = function (_PureComponent) {
  (0, _inherits3.default)(ProjectLegendLine, _PureComponent);

  function ProjectLegendLine() {
    (0, _classCallCheck3.default)(this, ProjectLegendLine);
    return (0, _possibleConstructorReturn3.default)(this, (ProjectLegendLine.__proto__ || (0, _getPrototypeOf2.default)(ProjectLegendLine)).apply(this, arguments));
  }

  (0, _createClass3.default)(ProjectLegendLine, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          hideWatermark = _props.hideWatermark;
      var t = this.context.t;


      return _react2.default.createElement(
        'span',
        { className: (0, _bind2.default)(styles.legendLine, className) },
        _react2.default.createElement(
          'span',
          { className: styles.legend },
          _react2.default.createElement(_ProjectIrefImage2.default, null),
          ' - ',
          t('internal ref')
        ),
        !hideWatermark && _react2.default.createElement(
          'span',
          { className: styles.legend },
          _react2.default.createElement('span', { className: styles.watermarkSign }),
          ' - ',
          t('watermark')
        )
      );
    }
  }]);
  return ProjectLegendLine;
}(_react.PureComponent), _class.propTypes = {
  className: _propTypes2.default.string,
  hideWatermark: _propTypes2.default.bool
}, _class.contextTypes = {
  t: _propTypes2.default.func
}, _temp);
exports.default = ProjectLegendLine;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ProjectLegendLine/ProjectLegendLine.js
// module id = 517
// module chunks = 1